<template>
  <div class="tips-container__wrapper">
    <div class="tips-container">
      <div
        style="margin-top: 60px"
        v-if="!storeData.root_name"
        v-loading="true"
      />
      <div v-else>
        <img
          v-if="storeData.cover_url"
          :src="storeData.cover_url"
          class="store-cover"
          width="100%"
          :height="imgHeight"
        />
        <!-- <div class="store-name">
          <span>{{ storeData.root_name }} | {{ storeData.display_name }}</span>
        </div>
        <a
          :href="`https://maps.google.com/?q=${storeData.display_location_name},${storeData.display_location_state}`"
          target="_blank"
          class="row-info mt15"
        >
          <div class="icon-info-wrapper">
            <img src="@/assets/ic_home_location.png" class="icon-info" />
          </div>
          <span style="line-height: 25px; font-size: 14px"
            >{{ storeData.display_location_name }},
            {{ storeData.display_location_state }}
          </span>
        </a> -->
      </div>
      <div class="list-technician">
        <el-input
          v-model="searchText"
          placeholder="Search your tech"
          :style="'width: 100%; margin: 15px;'"
          clearable
        />
        <div
          v-for="(item, index) in tech"
          :key="item.user_id"
          class="btn-tech normal-button"
          v-bind:class="{
            left: index % 3 == 0,
            right: index % 3 == 2,
            center: index % 3 == 1,
          }"
          @click="onSelectedTech(item)"
        >
          <img
            v-if="item.avatar_url"
            class="tech-image"
            :src="item.avatar_url"
          />
          <div v-else class="tech-image tech-image-text">
            <span>{{ getAvatarText(item.full_name) }}</span>
          </div>
          <span class="tech">{{
            item.full_name === "Anyone" ? "Salon" : item.full_name
          }}</span>
          <div class="payment-small_wrapper">
            <img
              v-if="item.venmo"
              src="@/assets/venmo.svg"
              class="payment-item_small"
            />
            <img
              v-if="item.cashapp"
              src="@/assets/cash.svg"
              class="payment-item_small"
            />
            <img
              v-if="item.paypal"
              src="@/assets/paypal_small.svg"
              class="payment-item_small"
            />
          </div>
        </div>
      </div>

      <el-dialog
        v-if="selectedTech != null"
        :visible.sync="dialogTipVisible"
        :width="dialogWidth"
        center="true"
        @close="
          () => {
            dialogTipVisible = false;
            selectedTech = null;
          }
        "
      >
        <div class="dialog-tech-body">
          <img
            v-if="selectedTech.avatar_url"
            class="tech-image"
            :src="selectedTech.avatar_url"
          />
          <div v-else class="tech-image tech-image-text">
            <span>{{ getAvatarText(selectedTech.full_name) }}</span>
          </div>
          <span class="tech">{{ selectedTech.full_name }}</span>
        </div>
        <div class="dialog-tech-bottom">
          <a
            v-if="selectedTech.venmo"
            :href="selectedTech.venmo"
            target="_blank"
            @click="onTipClick('Venmo')"
          >
            <img src="@/assets/venmo.svg" class="payment-item normal-button" />
          </a>
          <a
            v-if="selectedTech.cashapp"
            :href="selectedTech.cashapp"
            target="_blank"
            @click="onTipClick('Cashapp')"
          >
            <img src="@/assets/cash.svg" class="payment-item normal-button" />
          </a>
          <a
            v-if="selectedTech.paypal"
            :href="selectedTech.paypal"
            target="_blank"
            @click="onTipClick('Paypal')"
          >
            <img
              src="@/assets/paypal_small.svg"
              class="payment-item normal-button"
            />
          </a>
        </div>
        <div style="height: 20px" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getTechnician, getDisplayName } from "@/api/home";
export default {
  data() {
    return {
      storeData: {},
      technician: [],
      storeName: "",
      selectedTech: null,
      dialogTipVisible: false,
      searchText: "",
      windowWidth: Math.min(600, window.innerWidth),
    };
  },
  methods: {
    onTipClick(method) {
      this.$mixpanel.track("Tip technician", { method });
    },
    onResize() {
      this.windowWidth = Math.min(600, window.innerWidth);
    },
    getAvatarText(name) {
      const splited = name.split(" ");
      if (splited.length === 1) {
        return splited[0].charAt(0).toUpperCase();
      }
      return `${splited[0].charAt(0).toUpperCase()}${splited[1]
        .charAt(0)
        .toUpperCase()}`;
    },
    onSelectedTech(item) {
      this.selectedTech = item;
      this.dialogTipVisible = true;
      this.$mixpanel.track("Select technician", item);
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    imgHeight() {
      return this.windowWidth / 3;
    },
    tech() {
      if (this.searchText) {
        return this.technician.filter((t) =>
          t.full_name.toLowerCase().includes(this.searchText.toLowerCase())
        );
      }
      return this.technician;
    },
    device() {
      return this.$store.state.app.device;
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    dialogWidth() {
      if (this.isMobile) return "100%";
      return "600px";
    },
  },
  created() {
    this.storeName = this.$route.query.storename;
    getTechnician(this.storeName).then((res) => {
      this.technician = res.filter(
        (tech) =>
          !!tech.cashapp || !!tech.zelle || !!tech.venmo || !!tech.paypal
      );
    });
    getDisplayName(this.storeName).then((res) => {
      this.storeData = res;
    });
    this.$mixpanel.track("Init Web");
  },
};
</script>

<style lang="scss">
.tips-container {
  .el-dialog__close {
    font-size: 30px !important;
  }
}
.list-technician {
  .el-input__inner {
    background-color: #fff;
  }
}
</style>

<style lang="scss" scoped>
.tips-container__wrapper {
  padding-left: calc(50% - 300px);
  padding-right: calc(50% - 300px);
}
.icon-info-wrapper {
  height: 20px;
  width: 20px;
  margin-right: 15px;
  display: flex;
  justify-content: center;
}
.icon-info {
  height: 16px;
  width: auto;
}
.store-cover {
  object-fit: cover;
}
.store-name {
  font-weight: bold;
  font-size: 20px;
  margin: 10px 20px 0 20px;
}
.underline {
  text-decoration: underline;
}
.row-info {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-right: 20px;
}
.tips-container {
  display: flex;
  flex-direction: column;
  color: #222222;
  padding-left: 0px;
  padding-right: 0px;
  width: 100%;
  height: 100vh;
  background: #fff9ec;
  overflow: auto;
  .list-technician-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }
  .bottom-view {
    flex: 1;
    background: white;
  }
  .list-technician {
    display: flex;
    flex-wrap: wrap;
  }
  .btn-tech {
    padding: 15px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-radius: 6px;
    width: calc(33% - 6px);
    margin-bottom: 5px;
  }
  .payment-small_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5px;
    .payment-item_small {
      height: 20px;
      width: auto;
      margin: 1.5px;
    }
  }
  .left {
    margin-right: 5px;
  }
  .right {
    margin-left: 5px;
  }
  .center {
    margin-left: 5px;
    margin-right: 5px;
  }
  .tech {
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    margin-top: 10px;
  }
  .copy-content {
    font-weight: 600;
    font-size: 14px;
    text-align: center;
  }
  .tech-image {
    width: 60px;
    height: 60px;
    border-radius: 30px;
    object-fit: cover;
  }
  .tech-image-text {
    background-color: #2e2323;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 24px;
    font-weight: 600;
  }
  .dialog-copy-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
  }
  .dialog-tech-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    .tech {
      font-weight: 600;
      font-size: 30px;
      text-align: center;
      margin-top: 30px;
    }
    .tech-image {
      width: 100px;
      height: 100px;
      border-radius: 50px;
    }
    .tech-image-text {
      background-color: #2e2323;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 50px;
      font-weight: 600;
    }
  }
  .dialog-tech-bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
    .payment-item {
      width: 50px;
      height: 50px;
      margin: 5px;
    }
  }
  .dialog-copy-bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
}
@media only screen and (max-width: 600px) {
  .tips-container {
    padding-left: 0;
    padding-right: 0;
  }
  .tips-container__wrapper {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>